import { render, staticRenderFns } from "./TakeExam.vue?vue&type=template&id=496c8cc2&lang=pug&"
import script from "./TakeExam.vue?vue&type=script&lang=js&"
export * from "./TakeExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports